import { useState } from "react";
import TableResponsive from "../../TableResponsive";
import useFormat from "../../../hooks/utils/useFormat";
import StatusFlag from "../../StatusFlag";
import { ModalAddTask } from "../../Modal";
import useWrapper from "../../../hooks/useWrapper";

export default function ListView(props) {
  const { events, setreload, reload } = props;
  const { me } = useWrapper();
  const { formatDate } = useFormat();

  const getStatusLabel = __event => {
    if (!!__event.done) {
      return "Concluída";
    } else if (__event.end < new Date()) {
      return "Atrasada";
    } else if (__event.status === "foreseen") {
      return "Prevista";
    } else if (__event.status === "confirmed") {
      return "Confirmada";
    } else {
      return "Erro";
    }
  };

  const [eventSelect, seteventSelect] = useState();
  return (
    <>
      <TableResponsive
        emptyMsg="Nenhum tarefa encontrado."
        table={{
          head: [{ data: "ID" }, { data: "Nome" }, { data: "Data" }, { data: <div className="text-end">Status</div> }],
          body:
            events.map(__event => {
              return {
                ...(me.type === "Gestor"
                  ? {
                      onClick: () => {
                        seteventSelect(__event.id);
                      },
                    }
                  : {}),
                data: [
                  { element: __event.id },
                  { element: __event.title },
                  { element: !!__event.start?.getDate() ? formatDate(__event.start, 1) : "Data Inválida" },
                  {
                    element: (
                      <div className="text-end">
                        <StatusFlag status={getStatusLabel(__event)} />
                      </div>
                    ),
                  },
                ],
              };
            }) || [],
        }}
      />
      {me.type === "Gestor" && (
        <ModalAddTask
          reload={() => {
            setreload(!reload);
          }}
          itemId={eventSelect}
          show={!!eventSelect}
          onHide={() => seteventSelect(null)}
        />
      )}
    </>
  );
}

ListView.title = () => {};
